var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF200;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.5,135.6c-35,0-63.4-28.5-63.4-63.4S37.6,8.7,72.5,8.7S136,37.2,136,72.1S107.5,135.6,72.5,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.5,137.1c-35.9,0-65-29.1-65-65s29.1-65,65-65s65,29.1,65,65S107.4,137.1,71.5,137.1z M111.3,41.8 c5.5-5.5-2.6-13.7-8.1-8.2L80.5,56.4L30.2,44.2l-8.3,8.3l41.9,21.2L46.8,90.6l-12.9-1.4l-6.6,6.5l14.8,7.8l7.7,14.8l6.6-6.6 l-1.6-13l16.9-16.9L93,123.6l8.3-8.3L88.7,64.5L111.3,41.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/air.82d963f7b8c5550a1254132ad9725140.svg";
export { ForwardRef as ReactComponent };